import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isValidAge = (dobYear, dobMonth, dobDay) => {
  var now = Date.now();
  var old = new Date(dobYear + 100, dobMonth - 1, dobDay);
  var young = new Date(dobYear + 18, dobMonth - 1, dobDay);
  return {
    tooOld: old <= now,
    tooYoung: young > now
  };
};

var isValidDate = (year, month, day) => {
  var date = new Date(year, month - 1, day);
  var isValidYear = date.getFullYear() === year;
  var isValidMonth = date.getMonth() === month - 1;
  var isValidDay = date.getDate() === day;
  return isValidYear && isValidMonth && isValidDay;
};

var dobValidation = dateObject => {
  var {
    year,
    month,
    day
  } = dateObject;
  var intYear = parseInt(year, 10);
  var intMonth = parseInt(month, 10);
  var intDay = parseInt(day, 10);

  var result = _objectSpread(_objectSpread({}, isValidAge(intYear, intMonth, intDay)), {}, {
    invalidDate: !isValidDate(intYear, intMonth, intDay)
  });

  result.errors = Object.keys(result).filter(key => result[key]);
  result.isValid = !result.errors.length;
  return result;
};

export { dobValidation };